import React from "react";

/**
 * DS SelectCard — figma 1703:129011 "button/subscribe".
 *
 * 타이틀 + 설명이 함께 있는 선택형 카드. 선택 시 primary-50(4% 틴트) bg/border 와
 * accent 타이틀로 전환된다. 2열 그리드는 `.ds-select-card-grid` 로 감싼다.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {React.ReactNode} [props.desc]
 * @param {boolean} [props.selected]
 * @param {boolean} [props.disabled]
 * @param {() => void} props.onClick
 */
const DSSelectCard = ({ title, desc, selected, disabled, onClick }) => (
  <button
    type="button"
    disabled={disabled}
    aria-pressed={!!selected}
    className={["ds-select-card", selected && "ds-select-card--selected"]
      .filter(Boolean)
      .join(" ")}
    onClick={onClick}
  >
    <span className="ds-select-card__title">{title}</span>
    {desc ? <span className="ds-select-card__desc">{desc}</span> : null}
  </button>
);

export default React.memo(DSSelectCard);
